import { appendCustomTextResponse } from "../../../store/conversation.tsx";
import { updateSignUpState } from "../../../store/auth.tsx";
import axios from "../../../utils/axios.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

const handleAgreeToTermsAndConditions = async (
  trimmedText: string,
  dispatch: any,
) => {
  if (
    trimmedText.toLowerCase() !==
    i18n
      ._(
        msg({
          message: "Agree",
          context: "Command issued by the user to accept terms and conditions.",
        }),
      )
      .toLowerCase()
  ) {
    return dispatch(
      appendCustomTextResponse(
        i18n._(
          msg({
            message:
              "To confirm that you agree to our terms and conditions, please type 'Agree'.",
            context:
              "Message shown to the user informing him on how to agree to the terms and conditions.",
          }),
        ),
      ),
    );
  }

  const dataAgreementResponse = await fetchDataProtectionAgreement();
  if (!dataAgreementResponse) {
    return dispatch(
      appendCustomTextResponse(
        i18n._(
          msg({
            message:
              "I had some issues fetching the data protection policy. Please raise a support issue.",
            context:
              "Message shown to the user when there is an error while trying to detch the data protection policy",
          }),
        ),
      ),
    );
  }

  dispatch(
    appendCustomTextResponse(
      i18n._(
        msg({
          message: `Thank you! One final thing before you're good to go.  
    At Tally, we take data protection and privacy very seriously 🔐.  
    Please open and read the <a href="${dataAgreementResponse.data.content}" target="_blank" rel="noopener noreferrer">Data Protection Policy</a> 📜.  
    If you agree, type 'Agree'.`,
          context:
            "Message which urges the user to accept the data protection policy.",
        }),
      ),
    ),
  );

  dispatch(
    updateSignUpState({
      dataProtectionPolicyHash: dataAgreementResponse.data.agreement_hash,
    }),
  );
};

const fetchDataProtectionAgreement = async () => {
  try {
    const dataAgreementResponse = await axios.get(
      "/v1/anonymous/data_protection_policy/",
    );
    if (dataAgreementResponse.status !== 200) {
      return null;
    }
    return dataAgreementResponse;
  } catch (error) {
    return null;
  }
};

export default handleAgreeToTermsAndConditions;
